"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Drafts_exports = {};
__export(Drafts_exports, {
  default: () => Drafts_default
});
module.exports = __toCommonJS(Drafts_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.1602 15.25C17.1602 15.7057 16.9974 16.0964 16.6719 16.4219C16.3464 16.7474 15.9557 16.9102 15.5 16.9102H3.83984C3.37109 16.9102 2.97396 16.7474 2.64844 16.4219C2.32292 16.0964 2.16016 15.7057 2.16016 15.25V3.58984H2.19922C2.30339 3.10807 2.54427 2.71094 2.92188 2.39844C3.29948 2.07292 3.74219 1.91016 4.25 1.91016H5.08984C5.3112 1.91016 5.5 1.99479 5.65625 2.16406C5.82552 2.32031 5.91016 2.51562 5.91016 2.75V3.58984H13.5078L14.3867 2.69141C14.8424 2.23568 15.3958 1.98828 16.0469 1.94922C16.6979 1.91016 17.2773 2.09896 17.7852 2.51562C18.3711 2.98438 18.6836 3.59635 18.7227 4.35156C18.7747 5.10677 18.5273 5.7513 17.9805 6.28516L17.1602 7.125V15.25ZM3.78125 14.4688C3.54688 14.5208 3.39062 14.6055 3.3125 14.7227C3.23438 14.8398 3.1888 14.9505 3.17578 15.0547V15.25C3.17578 15.4323 3.24089 15.5885 3.37109 15.7188C3.5013 15.849 3.65755 15.9141 3.83984 15.9141H15.5C15.6823 15.9141 15.8385 15.849 15.9688 15.7188C16.099 15.5885 16.1641 15.4323 16.1641 15.25V8.12109L12.1992 12.0859C11.9909 12.2943 11.7565 12.4701 11.4961 12.6133C11.2487 12.7565 10.9883 12.8672 10.7148 12.9453L8.42969 13.5703C8.13021 13.6484 7.86328 13.5898 7.62891 13.3945C7.40755 13.1862 7.32292 12.9323 7.375 12.6328L7.78516 10.1719C7.85026 9.83333 7.96094 9.50781 8.11719 9.19531C8.27344 8.88281 8.47526 8.60286 8.72266 8.35547L12.4922 4.58594H5.91016V13.5898C5.91016 13.8112 5.82552 14.0065 5.65625 14.1758C5.5 14.332 5.3112 14.4102 5.08984 14.4102H4.25C4.15885 14.4102 4.07422 14.4167 3.99609 14.4297C3.91797 14.4427 3.84635 14.4557 3.78125 14.4688ZM3.17578 13.6289C3.31901 13.5508 3.48177 13.4987 3.66406 13.4727C3.84635 13.4336 4.04167 13.4141 4.25 13.4141H4.91406V2.92578H4.25C3.95052 2.92578 3.69661 3.02995 3.48828 3.23828C3.27995 3.44661 3.17578 3.70052 3.17578 4V13.6289ZM8.41016 12.5352L10.4414 11.9883C10.6367 11.9362 10.819 11.8581 10.9883 11.7539C11.1706 11.6497 11.3333 11.526 11.4766 11.3828L15.793 7.06641L13.6055 4.87891L9.42578 9.07812C9.25651 9.2474 9.11328 9.44271 8.99609 9.66406C8.89193 9.8724 8.82031 10.0938 8.78125 10.3281L8.41016 12.5352ZM14.2109 4.29297L16.3789 6.48047L17.2773 5.58203C17.6029 5.25651 17.7526 4.86589 17.7266 4.41016C17.7005 3.95443 17.5117 3.58333 17.1602 3.29688C16.8477 3.04948 16.4961 2.9388 16.1055 2.96484C15.7148 2.97786 15.3763 3.12109 15.0898 3.39453L14.2109 4.29297Z",
      fill: "currentColor"
    }
  )
);
const SvgDrafts = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Drafts_default = SvgDrafts;
